import { Typography } from "@mui/material";
import React from "react";
import SectionHeader from "./SectionHeader";
import DetailCaption from "./DetailCaption";

function DressCode() {
  return (
    <>
      <SectionHeader>Dress Code</SectionHeader>
      <DetailCaption>
        Today's styles challenge us, but our dress code is designed to exemplify
        Godly principles in appearance and bearing.
      </DetailCaption>
      <Typography variant="body2">
        Webster's definition of modest describes it as "reserved, proper,
        decent, quiet, humble, not pretentious. Having or showing regard for the
        decencies of behavior, speech, dress, etc."
      </Typography>
      <Typography variant="body2">
        <ul>
          <li>
            <b>
              The dress code for all activities at Harmony Hill is a requirement
            </b>
            , not an option.
          </li>
          <li>
            <b>The dress code applies to ALL</b> who come to attend, visit, help
            set up or help break down camp.
          </li>
          <li>
            <b>Parents who are not attending</b>, please abide by the dress code
            when you bring your child or pick up your child.
          </li>
          <li>
            Please do not bring shirts, blouses, or other articles of clothing
            with <b>slogans, logos or graphics</b>
            which are inconsistent with our GUIDELINES.
          </li>
          <li>
            <b>Questions regarding the dress code</b> should be directed to
            qualified administrative personnel.
          </li>
        </ul>
      </Typography>
      <SectionHeader>Boys (12 and Older)</SectionHeader>
      <DetailCaption>Pants</DetailCaption>
      <Typography variant="body2">
        <ul>
          <li>Must wear long pants</li>
          <li>Must be neat, modest</li>
          <li>Must cover knees while seated or standing</li>
          <li>Waistbands must be worn at the waist</li>
        </ul>
      </Typography>
      <DetailCaption>Shirts</DetailCaption>
      <Typography variant="body2">
        <ul>
          <li>Must have sleeves</li>
          <li>Must be tucked in or hanging several inches below the waist</li>
          <li>
            Shirts and pants must stay together when standing, stooping,
            reaching, etc.
          </li>
        </ul>
      </Typography>
      <DetailCaption>Hats</DetailCaption>
      <Typography variant="body2">
        <ul>
          <li>No caps, hats, visors while in buildings or while eating</li>
        </ul>
      </Typography>
      <DetailCaption>Jewelry</DetailCaption>
      <Typography variant="body2">
        <ul>
          <li>No jewelry other than class ring and/or watch</li>
        </ul>
      </Typography>
      <SectionHeader>Girls (12 and Older)</SectionHeader>
      <DetailCaption>Pants & Skirts</DetailCaption>
      <Typography variant="body2">
        <ul>
          <li>May wear pants, loose-fitting capris, dresses and skirts</li>
          <li>Must cover knees while seated and standing</li>
          <li>No slits or openings that open the garment above the knees</li>
        </ul>
      </Typography>
      <DetailCaption>Shirts</DetailCaption>
      <Typography variant="body2">
        <ul>
          <li>
            If sleeveless, you may be asked to wear a short-sleeved blouse as a
            cover
          </li>
          <li>Must hang several inches below tops of pants or skirt</li>
          <li>
            Shirt/blouse and pants/skirt must stay together when standing,
            stooping, reaching, etc.
          </li>
          <li>
            Dresses, shirts, and blouses may not have immodestly low-cut
            necklines
          </li>
        </ul>
      </Typography>
      <DetailCaption>Sleepwear</DetailCaption>
      <Typography variant="body2">
        <ul>
          <li>
            Must wear housecoat or robe over sleepwear except when sleeping
          </li>
        </ul>
      </Typography>
      <DetailCaption>Jewelry</DetailCaption>
      <Typography variant="body2">
        <ul>
          <li>Finger rings, simple earrings, simple necklaces, watches</li>
          <li>No other "body" jewelry is allowed</li>
        </ul>
      </Typography>
      <SectionHeader>Children (11 and under)</SectionHeader>
      <Typography variant="body2">
        <ul>
          <li>May wear shorts</li>
          <li>No short-shorts</li>
        </ul>
      </Typography>
    </>
  );
}

export default DressCode;
